var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 300,
    viewBox: "0 0 379 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.839 300C303.833 300.392 378.673 233.13 378.673 151.304C378.673 61.8214 303.833 -0.0297512 221.839 1.07361e-05H151.274C68.2976 -0.0297512 0 61.8399 0 151.304C0 233.148 68.2976 300.393 151.274 300H221.839Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.608 12.3989C75.7865 12.4227 14.346 73.8811 14.3281 149.733C14.346 225.572 75.7859 287.024 151.608 287.048C227.447 287.024 288.9 225.572 288.911 149.733C288.9 73.8811 227.447 12.4227 151.608 12.3989ZM64.59 149.733C64.6615 112.667 87.8103 81.0602 120.453 68.5001V230.947C87.8103 218.394 64.6609 186.804 64.59 149.733ZM182.751 230.982V68.4948C215.406 81.0245 238.59 112.65 238.65 149.733C238.59 186.827 215.406 218.429 182.751 230.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.839 300C303.833 300.392 378.673 233.13 378.673 151.304C378.673 61.8214 303.833 -0.0297512 221.839 1.07361e-05H151.274C68.2976 -0.0297512 0 61.8399 0 151.304C0 233.148 68.2976 300.393 151.274 300H221.839Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.608 12.3989C75.7865 12.4227 14.346 73.8811 14.3281 149.733C14.346 225.572 75.7859 287.024 151.608 287.048C227.447 287.024 288.9 225.572 288.911 149.733C288.9 73.8811 227.447 12.4227 151.608 12.3989ZM64.59 149.733C64.6615 112.667 87.8103 81.0602 120.453 68.5001V230.947C87.8103 218.394 64.6609 186.804 64.59 149.733ZM182.751 230.982V68.4948C215.406 81.0245 238.59 112.65 238.65 149.733C238.59 186.827 215.406 218.429 182.751 230.982Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378.571,
    height: 300,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/Diners_Club.cf40d0be.svg";
export { ForwardRef as ReactComponent };